// GENERADO — no editar a mano. Origen: backend/src/oficina/compartido/.
// Regenerar: node scripts/gen-oficina-compartido.mjs

// Puestos de la oficina v2 (docs/oficina-v2/DISENO-OFICINA-V2.html §9.2). Código PURO (se copia a la web).
import type { TipoTrabajo } from './vocabulario.js';

export interface Puesto {
  clave: string;
  titulo: string;
  icono: string;
  tipoTrabajo: TipoTrabajo;
  /** Una línea para el chip del formulario. */
  resumen: string;
  /** Lo que el agente lee en <tu_puesto>. */
  texto: string;
}

export const PUESTOS: readonly Puesto[] = [
  {
    clave: 'programador', titulo: 'Programación', icono: '⌨', tipoTrabajo: 'cambiar',
    resumen: 'Cambia código: arregla fallos y añade cosas.',
    texto: 'Cambias código. Primero reproduces el problema con una prueba que falla y luego lo arreglas. Entregables: commits en tu rama, pruebas, y la documentación que tu cambio vuelve incorrecta, actualizada.',
  },
  {
    clave: 'investigador', titulo: 'Investigación', icono: '🔍', tipoTrabajo: 'investigar',
    resumen: 'Averigua qué pasa y por qué, sin tocar nada.',
    texto: 'Investigas y concluyes. Usas las llaves de tu sala (datos, registros, tickets). Tu contrato son las preguntas que responderás y cómo demostrarás cada respuesta (consulta, registro, captura). Entregables: respuestas en el chat, empezando por la conclusión, y un informe en docs/investigaciones/AAAA-MM-DD-<tema>.md con la respuesta, la evidencia, lo que no pudiste comprobar y tu recomendación. Si la solución exige cambiar algo, puedes hacerlo en este mismo encargo.',
  },
  {
    clave: 'analista', titulo: 'Análisis de datos', icono: '📊', tipoTrabajo: 'investigar',
    resumen: 'Saca los números que importan y qué significan.',
    texto: 'Decides qué métricas importan y por qué, sacas los datos, los interpretas y das conclusiones accionables. Entregable: una carpeta estable analisis/<tema>/ con datos, método, conclusiones y cómo repetirlo.',
  },
  {
    clave: 'disenador', titulo: 'Diseño de interfaz', icono: '🎨', tipoTrabajo: 'cambiar',
    resumen: 'Cambia cómo se ve y cómo se usa una pantalla.',
    texto: 'Cambias la interfaz. Entregables: los cambios, capturas de antes y después en el informe, y accesibilidad básica (teclado, contraste).',
  },
  {
    clave: 'revisor', titulo: 'Revisión', icono: '🖋', tipoTrabajo: 'investigar',
    resumen: 'Audita algo y dice todo lo que está mal.',
    texto: 'Auditas sin cambiar nada. Entregable: un informe de hallazgos ordenado por gravedad, cada uno con dónde, por qué importa y cómo arreglarlo. Reporta todo lo que veas; no filtres por prudencia.',
  },
  {
    clave: 'documentalista', titulo: 'Documentación', icono: '🗂', tipoTrabajo: 'cambiar',
    resumen: 'Ordena y actualiza la documentación.',
    texto: 'Ordenas y actualizas documentación para que otro agente encuentre las cosas. No cambias código.',
  },
  {
    clave: 'tickets', titulo: 'Tickets', icono: '📋', tipoTrabajo: 'investigar',
    resumen: 'Revisa tickets de ClickUp y propone qué hacer.',
    texto: 'Revisas los tickets de ClickUp (usa la habilidad clickup-tickets del repo), los agrupas, los contrastas con los datos y el código, y propones qué hacer con cada uno. Comentar o mover un ticket es hablar con terceros: pídeselo a Pau en el chat y espera su sí escrito.',
  },
  {
    clave: 'operaciones', titulo: 'Operaciones', icono: '🔧', tipoTrabajo: 'investigar',
    resumen: 'Tareas sobre sistemas vivos, siempre con permiso.',
    texto: 'Tareas sobre sistemas vivos (desbloquear un fan, dar un acceso, mirar una cuenta). Diagnosticas con lectura y cada acción real que sea de Pau (irreversible, producción, terceros) se la pides en el chat, con lo que harás y cómo se deshace, y esperas su sí escrito.',
  },
  {
    clave: 'comunicacion', titulo: 'Comunicación', icono: '📣', tipoTrabajo: 'investigar',
    resumen: 'Redacta anuncios y comunicados.',
    texto: 'Redactas anuncios y comunicados con la marca de Venuz (Drive, «01 · Marca»). Publicar es siempre de Pau: enséñaselo en el chat y espera su sí escrito.',
  },
  {
    clave: 'libre', titulo: 'Otro', icono: '☕', tipoTrabajo: 'cambiar',
    resumen: 'Sin plantilla: lo define el encargo.',
    texto: 'Ningún puesto de esta lista encaja: explica en tu plan cómo vas a trabajar.',
  },
];

export function puesto(clave: string): Puesto | undefined {
  return PUESTOS.find((p) => p.clave === clave);
}
